import { createAction } from "redux-act";

export const OpenNodeNewModalAction = createAction("Node New - Open Modal");
export const CloseNodeNewModalAction = createAction("Node New - Close Modal");
